<template>
  <div id='pluginContainer'>
    <router-view v-if='pluginLoaded'>
    </router-view>
  </div>
</template>

<script>
  import PluginSiteNav from '@/components/Nav/PluginSiteNav'
  import {
    webAuth
  } from '@/auth'
  import {
    aaPubnub
  } from '@/lib/pubnub'
  import {
    subscriber,
    listener
  } from '@/lib/pubnub/pubnubListeners'
  export default {
    components: {
      PluginSiteNav
    },
    data: function () {
      return {
        pluginLoaded: false,
        isMobile: true,
        user: {},
      }
    },
    created() {
      let vm = this;
      if (vm.$route.query.authToken) {
        webAuth.loginAAToken(vm.$route.query.authToken).then(function () {
          //  vm.user = Object.assign({},webAuth.user)
          vm.$http.get('/message/vendor').then(function (response) {
            let vendorInfo = response.data.Data
            vm.pnInstance = aaPubnub.getInstance();
            vm.pnInstance.setVendorInfo(vendorInfo);
            vm.$http.get('/account/currentUser').then(function (resp) {
              let user = resp.data.Data;
              vm.pnInstance.setupPubnub(vendorInfo, user.ES_StaffID);
              vm.pnInstance.pubnub.addListener(listener(vendorInfo, vm));
              vm.pnInstance.pubnub.subscribe(subscriber(vendorInfo, vm));
              vm.$store.dispatch('setCurrentUser', user)
              vm.pluginLoaded = true;
            })
          })
        })
      } else {
        window.ManualAuth = function (authToken) {
          webAuth.loginAAToken(authToken).then(function () {
            //  vm.user = Object.assign({},webAuth.user)
            vm.$http.get('/message/vendor').then(function (response) {
              let vendorInfo = response.data.Data
              vm.pnInstance = aaPubnub.getInstance();
              vm.pnInstance.setVendorInfo(vendorInfo);
              vm.$http.get('/account/currentUser').then(function (resp) {
                let user = resp.data.Data;
                vm.pnInstance.setupPubnub(vendorInfo, user.ES_StaffID);
                vm.pnInstance.pubnub.addListener(listener(vendorInfo, vm));
                vm.pnInstance.pubnub.subscribe(subscriber(vendorInfo, vm));
                vm.$store.dispatch('setCurrentUser', user)
                vm.pluginLoaded = true;
              })
            })
          })
        }
      }
    }
  }

</script>

<style lang='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/views/Plugin/Plugin.vue